import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; 
import JsQuiz from '../pages/JsQuiz';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Button from '@mui/material/Button';

const JsCourse = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showQuiz, setShowQuiz] = useState(false);
    const [showAlert, setShowAlert] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('token');
        setIsLoggedIn(!!token);
    }, []);

    const handleStartQuiz = () => {
        if (isLoggedIn) {
            setShowQuiz(true);
        } else {
            setShowAlert(true);
        }
    };

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    return (
        <div className="container mt-5">
            <h1>{t('jsCourse.title')}</h1>
            <p>{t('jsCourse.description')}</p>

            <h2>{t('jsCourse.contentTitle')}</h2>
            <ul>
                {[
                    { path: '/js-course/introduction', label: 'introduction' },
                    { path: '/js-course/variables', label: 'variables' },
                    { path: '/js-course/functions', label: 'functions' },
                    { path: '/js-course/objects', label: 'objects' },
                    { path: '/js-course/events', label: 'events' },
                    { path: '/js-course/domManipulation', label: 'domManipulation' },
                ].map(({ path, label }) => (
                    <li key={path}>
                        <Link to={path} className="text-decoration-none text-primary">
                            {t(`jsCourse.${label}`)}
                        </Link>
                    </li>
                ))}
            </ul>

            <h2 className="mt-5">{t('jsCourse.objectivesTitle')}</h2>
            <p>{t('jsCourse.objectivesDescription')}</p>
            <ul>
                {[1, 2, 3].map(num => (
                    <li key={num}>{t(`jsCourse.objective${num}`)}</li>
                ))}
            </ul>

            <h2 className="mt-5">{t('jsCourse.quizzesTitle')}</h2>
            <p>{t('jsCourse.quizzesDescription')}</p>
            <button 
                onClick={handleStartQuiz} 
                className="btn btn-primary mt-3" 
                aria-label={t('jsCourse.startQuiz')}
            >
                {t('jsCourse.startQuiz')}
            </button>

            {showQuiz && <JsQuiz level={1} />}

            {showAlert && (
                <Alert
                    severity="warning"
                    onClose={handleCloseAlert}
                    action={
                        <Button
                            color="inherit"
                            size="small"
                            onClick={() => window.open("https://t.me/Positive_oo1", "_blank")}
                        >
                            {t("jsCourse.loginAlert.contactUs")}
                        </Button>
                    }
                    sx={{ mt: 3 }}
                >
                    <AlertTitle>{t("jsCourse.loginAlert.title")}</AlertTitle>
                    {t("jsCourse.loginAlert.message")}
                </Alert>
            )}
        </div>
    );
};

export default JsCourse;
